import { type CustomerFilters, OPS_CENTER_OPTIONS } from "./filters";

export type CustomersSearch = { q: string } & CustomerFilters;

function strings(raw: unknown): string[] {
  return Array.isArray(raw) ? raw.filter((v) => typeof v === "string") : [];
}

/**
 * Filters live in the URL so a filtered list can be bookmarked and sent to a
 * colleague. Every field falls back to a default, so a hand-edited or
 * truncated URL shows an unfiltered list rather than crashing the route.
 *
 * Hand-rolled rather than a zod schema on purpose. TanStack Router's auto code
 * splitting keeps validateSearch in the eager route config, so a zod schema
 * here drags zod into the entry chunk and every page load pays for it — which
 * matters for field techs on rural connectivity. Twenty lines buy that back.
 */
export function validateCustomersSearch(
  raw: Record<string, unknown>
): CustomersSearch {
  return {
    q: typeof raw.q === "string" ? raw.q : "",
    dealer: strings(raw.dealer),
    municipality: strings(raw.municipality),
    assignee: strings(raw.assignee),
    // Unknown states fall away rather than filtering everything out: a
    // hand-edited ?opsCenter=broken must not hand the reader an empty table.
    opsCenter: strings(raw.opsCenter).filter((state) =>
      OPS_CENTER_OPTIONS.some((known) => known === state)
    ),
  };
}

export const DEFAULT_CUSTOMERS_SEARCH = validateCustomersSearch({});
